export const BETA_APPLICATION_SUBJECT = 'Beta Program Application';

export const BETA_APPLICATION_MESSAGE =
  "I'd like to apply for the Laftel Lingo beta program. I'm excited to help shape the product " +
  'and share feedback as new features roll out.';
